import React, { useState, useRef } from 'react';
import { motion, useTransform } from 'framer-motion';

const VideoLaptop = ({ scrollProgress }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  // Animation Timeline (650vh):
  // Phase 1: Start at different position (bottom-right), grow (0 → 0.3)
  // Phase 2: Move to center while growing (0.3 → 0.5)
  // Phase 3: MAX SIZE HOLD - Sync with circles (0.5 → 0.7)
  // Phase 4: SHRINK TOGETHER - Laptop & White & Orange circles all shrink (0.7 → 0.8)
  // Phase 5: Gone, waiting for strip (0.8 → 1.0)
  
  // Scale: starts at 0.06, grows to 1.0, HOLDS, then shrinks to 0
  const scale = useTransform(scrollProgress, [0, 0.3, 0.5, 0.7, 0.8], [0.06, 0.5, 1, 1, 0]);
  
  // Position: starts bottom-right (350, 300), moves to center (0, 0) to become concentric
  const x = useTransform(scrollProgress, [0, 0.5, 0.7], [350, 0, 0]);
  const y = useTransform(scrollProgress, [0, 0.5, 0.7], [300, 0, 0]);
  
  const opacity = useTransform(scrollProgress, [0, 0.05, 0.75, 0.8], [1, 1, 1, 0]);

  // Always in front of circles
  const zIndex = 25;

  return (
    <motion.div
      style={{
        scale,
        x,
        y,
        opacity,
        zIndex,
        willChange: 'transform, opacity',
      }}
      className="fixed inset-0 flex items-center justify-center laptop"
    >
      {/* Laptop Frame */}
      <div className="relative pointer-events-auto" style={{ width: '900px', maxWidth: '90vw' }}>
        {/* Screen */}
        <div
          className="relative rounded-2xl overflow-hidden shadow-2xl cursor-pointer"
          style={{
            background: '#53644C',
            border: '12px solid #2a2a2a',
            aspectRatio: '16/10',
          }}
        >
          {/* Video Player */}
          <div className="absolute inset-0 flex items-center justify-center"
            style={{
              background: '#000',
            }}
          >
            {/* Actual Video */}
            <video
              ref={videoRef}
              className="w-full h-full object-cover"
              src="/video.mp4"
              playsInline
              onEnded={() => setIsPlaying(false)}
            />

            {/* Play/Pause Overlay */}
            {!isPlaying && (
              <div
                className="absolute inset-0 flex items-center justify-center cursor-pointer"
                onClick={handlePlayPause}
                style={{
                  background: 'rgba(0, 0, 0, 0.4)',
                }}
              >
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  className="w-20 h-20 rounded-full flex items-center justify-center"
                  style={{ background: 'var(--accent-orange)' }}
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M8 5v14l11-7L8 5z" fill="white" />
                  </svg>
                </motion.div>
              </div>
            )}

            {/* Click to pause when playing */}
            {isPlaying && (
              <div
                className="absolute inset-0 cursor-pointer"
                onClick={handlePlayPause}
              />
            )}
          </div>
        </div>

        {/* Laptop Base */}
        <div
          className="h-4 rounded-b-3xl"
          style={{
            background: 'linear-gradient(to bottom, #2a2a2a, #1a1a1a)',
            boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
          }}
        />
      </div>
    </motion.div>
  );
};

export default VideoLaptop;
